// PRIMERO, antes que cualquier otro import: guarda la invitación a una demo
// (`?demo=<token>`) y la quita de la URL antes de que Sentry o PostHog la lean.
import './utils/demoInviteBoot'
import { StrictMode } from 'react'
import { initSentry } from './sentry'
import { initPostHog } from './posthog'
import { startAnalyticsIdentitySync } from './analytics/identity'
import { startSandboxAnalyticsSync } from './analytics/sandboxAnalytics'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { startFeatureFlagsRevalidation } from './store/featureFlagsRuntimeStore'

initSentry();
// Envuelto: `initPostHog` toca window.location y el arranque de identidad lee
// localStorage, y los dos corren ANTES de createRoot. En un contexto donde el
// acceso a storage lanza (datos de sitio bloqueados, iframe en sandbox) la
// excepcion escaparia antes de montar React y la app quedaria en blanco:
// perder la analitica es mucho mejor que perder la aplicacion.
try {
  initPostHog();
  // Fuera de React a proposito: sobrevive al doble montaje de StrictMode y lee
  // al usuario ya rehidratado por el middleware `persist` del store.
  startAnalyticsIdentitySync();
  // Modo Sandbox en cada evento: separa en PostHog la actividad con datos de
  // ejemplo de la real.
  startSandboxAnalyticsSync();
} catch (error) {
  console.error("[Analytics] No se pudo inicializar la analitica:", error);
}

// Banderas globales (épica #1219): al arrancar, al volver a la pestaña y cada
// 5 minutos. Sin respuesta no se oculta nada (y si algo falla aquí, tampoco:
// perder las banderas es mejor que dejar la app en blanco).
try {
  startFeatureFlagsRevalidation();
} catch (error) {
  console.error("[FeatureFlags] No se pudo iniciar la revalidación:", error);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
